import axios from '@/config/axiosConfig';
import ApiKey from '@/service/constant/ApiKey';
import { MDT_URL, ADMIN_URL } from '@/service/constant/BaseApiUrl';

export default class CityService {
  getListManagement() {
    return axios.get(`${MDT_URL}${ApiKey.CITY}/${ApiKey.LIST_MANAGEMENT}`);
  }
  getCityGateways() {
    return axios.get(`${MDT_URL}${ApiKey.CITY}/gateways`);
  }
  getCityDestinations() {
    return axios.get(`${MDT_URL}${ApiKey.CITY}/destinations`);
  }

  addCity(payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.CITY}`, payload);
  }

  updateCity(payload: any) {
    return axios.put(`${MDT_URL}${ApiKey.CITY}`, payload);
  }

  deleteCity(payload: any) {
    return axios.delete(`${MDT_URL}${ApiKey.CITY}/${ApiKey.DELETE}`, payload);
  }

  getUrlPreview() {
    return `${MDT_URL}${ApiKey.CITY}/${ApiKey.PREVIEW}`;
  }

  importCity(payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.CITY}/${ApiKey.IMPORT}`, payload);
  }

  getVersionRevertCity(type: string) {
    return axios.get(`${ADMIN_URL}${ApiKey.ADMINISTRATION}/file?fileType=${type}`);
  }

  getPreviewFileCity(fileName: string) {
    return axios.post(`${MDT_URL}${ApiKey.CITY}/${ApiKey.URL_FILE}/${ApiKey.PREVIEW_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  revertFileCity(fileName: string) {
    return axios.post(`${MDT_URL}${ApiKey.CITY}/${ApiKey.REVERT_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  getDestAir() {
    return axios.get(`${MDT_URL}${ApiKey.CITY}/${ApiKey.GATE_DEST_AIR}`);
  }

  checkJawBrochure(jawType: string, payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.CITY}/${ApiKey.CHECK_JAW}/${jawType}`, payload);
  }
}
